import { SignCacheParams, SignCacheConfig } from '@byted/tiktok-zti-types';

let signTimeout = 60 * 60 * 1000 * 5; // 缓存五小时时间
const signCache: SignCacheParams = {};
let hasSetTimeout = false;

export const setSignTimeout = (time: number) => {
  if (!hasSetTimeout) {
    signTimeout = time;
  }
  hasSetTimeout = true;
};

export const getCacheSignString = (url: string, localTicket: string): string => {
  try {
    const sign_data = signCache[url];
    if (!sign_data) {
      return '';
    }
    const { timeout, signStr, ticket } = sign_data;
    if (ticket !== localTicket) {
      return '';
    }
    const nowTime = new Date().getTime();
    if (nowTime >= timeout) {
      return '';
    }
    if (signStr) {
      return signStr;
    }
  } catch (error) {
    console.log(error);
  }
  return '';
};

export const setCacheSignString = (url: string, localTicket: string, signStr: string) => {
  try {
    const nowTime = new Date().getTime();
    const signEffectiveTime = nowTime + signTimeout;
    const signCacheConfig: SignCacheConfig = {
      timeout: signEffectiveTime,
      signStr,
      ticket: localTicket,
      createTime: nowTime
    };
    signCache[url] = signCacheConfig;
  } catch (error) {
    console.log(error);
  }
};
